import React from 'react';

import { I18nProvider } from 'modules/shared-i18n';
import { Router, RouterProps } from './components';

const Root: React.FC<RouterProps> = (props: RouterProps) => {
    return (
        <I18nProvider>
            <Router {...props} />
        </I18nProvider>
    );
};

export default Root;
